import { ref } from 'vue'

const currentElementTypeId = ref<number | null>(null)

export function useCurrentElementType() {
  function setCurrentElementTypeId(id: number | null) {
    currentElementTypeId.value = id
  }

  return {
    currentElementTypeId,
    setCurrentElementTypeId,
  }
}
